"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAction = void 0;
const class_validator_1 = require("class-validator");
const base_action_1 = require("./base.action");
class UpdateAction extends base_action_1.BaseAction {
}
__decorate([
    class_validator_1.IsNumber(),
    class_validator_1.Min(1)
], UpdateAction.prototype, "version", void 0);
exports.UpdateAction = UpdateAction;
//# sourceMappingURL=update.action.js.map